import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { forwardRef } from "react";
import classnames from "classnames";
import styles from "@/styles/Form.module.scss";
import { usePreventContextMenu } from "@/hooks";
import { jsx as _jsx } from "react/jsx-runtime";
const SearchInputField = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      className
    } = props,
    _props = _objectWithoutProperties(props, _excluded);
  const [on, off] = usePreventContextMenu();
  return /*#__PURE__*/_jsx("div", {
    className: styles.searchInputField,
    children: /*#__PURE__*/_jsx("input", _objectSpread({
      ref: ref,
      className: classnames(styles.searchInput, className),
      defaultValue: "",
      type: "search",
      autoComplete: "off",
      onFocus: off,
      onBlur: on
    }, _props))
  });
});
SearchInputField.displayName = "SearchInputField";
export default SearchInputField;